import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const globalViewStyles = makeStyles((theme: Theme) =>
    createStyles({
        section: {
            marginBottom: 20,
        },

        alertsContainer: {
            display: "flex",
            flexDirection: "column",
        },

        dis: {
            position: "fixed",
            overflow: "auto",
            width: "100%",
            height: "100vh",
            backgroundColor: "rgba(82, 82, 82, 0.6)",
            zIndex: theme.zIndex.appBar - 1,
        },

        content: {
            flexGrow: 1,
            padding: theme.spacing(3),
            marginTop: "60px",
        },

        toolbar: {
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            padding: theme.spacing(0, 1),
            // necessary for content to be below app bar
            ...theme.mixins.toolbar,
        },

        noDataAvailableContainer: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        },
    })
);
